<template>

    <LoopItemPanel title="Categorie selecteren">
        <div class="common-canvas-blocks-custom-categories-admin-LoopItemPanel">

            <div class="tw-px-4 tw-py-3 text">
                <div class="tw-mb-1 tw-text-gray-600 label">Link</div>

                <input v-model="loopItem.link" class="focus:tw-border-indigo-500 focus:tw-ring-indigo-500 form-control sm:tw-text-sm tw-block tw-border tw-border-gray-300 tw-px-4 tw-py-2 tw-rounded tw-w-full" />

            </div>

            <ColorsInput
                    label="Achtergrondkleur"
                    instruction="Bepaal hier de achtergrondkleur van het gehele blok."
                    :colors="[
                    '#ffffff',
                    '#cbdee4',
                    '#e3cae0',
                    '#e4d6c9',
                ]"
                    :options="loopItem"
                    options-property="color" />

        </div>
    </LoopItemPanel>

</template>

<script>
    import axios from 'axios';
    import LoopItemPanel from "@galaxy/js/common/canvas/editor/canvas/document/editors/loop/LoopItemPanel";
    import SwitchInput from "../../../../../../../../packages/lav-galaxy/framework/resources/js/common/canvas/editor/canvas/document/editors/inputs/SwitchInput";
    import WebsitePageSelector from "../../../../../../../../packages/lav-galaxy/framework/resources/js/habitats/admin/common/WebsitePageSelector";
    import ColorsInput from "../../../../../../../../packages/lav-galaxy/framework/resources/js/common/canvas/editor/canvas/document/editors/inputs/ColorsInput";

    export default {
        extends: LoopItemPanel,
        components: {
            LoopItemPanel,
            SwitchInput,
            WebsitePageSelector,
            ColorsInput,
        },
        data()
        {
            return {

            };
        },
    }
</script>
<style lang="scss" scoped>
    .common-canvas-blocks-custom-categories-admin-LoopItemPanel {
    }

</style>
